<template>
  <div>
    <header-bar>LinkMAP レポート</header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <form>
          <div class="linkanalytic-search-wrap detail">
            <div>
              <div class="form-label form-label--linkanalytic">
                <label
                  class="control-label"
                  for="type">表示期間</label>
              </div>
              <div class="form-content">
                <div class="form-item">
                  <vue-ctk-date-time-picker
                    v-model="datepickerInternalValueSearchFrom"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    :min-date="minFrom"
                    :max-date="maxTo"
                    :no-label="true"
                    :no-header="true"
                    :overlay="true"
                    only-date>
                    <input
                      v-model="searchFrom"
                      class="linkanalytic-detail-input-search"
                      type="search"
                      @change="searchRadioUnselected" />
                  </vue-ctk-date-time-picker>
                  <span>〜</span>
                  <vue-ctk-date-time-picker
                    v-model="datepickerInternalValueSearchTo"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    :no-label="true"
                    :no-header="true"
                    :min-date="minFrom"
                    :max-date="maxTo"
                    :overlay="true"
                    only-date
                    @change="searchRadioUnselected">
                    <input
                      v-model="searchTo"
                      class="linkanalytic-detail-input-search"
                      type="search"
                      @change="searchRadioUnselected" />
                  </vue-ctk-date-time-picker>
                </div>
                <a
                  class="c-btn c-btn--search"
                  @click.prevent="onClickedSearch">
                  <img
                    src="/img/common/icon-search.png"
                    alt="">検索
                </a>
              </div>
              <div class="radio-group">
                <div class="radio">
                  <label for="daily-radio">
                    <input
                      id="daily-radio"
                      v-model="searchTermRadio"
                      type="radio"
                      name="searchDateRadio"
                      value="daily"
                      @click="searchRadioSelected('daily')">
                    <div class="option-input"></div> デイリー(7日間)
                  </label>
                </div>
                <div class="radio">
                  <label for="weekly-radio">
                    <input
                      id="weekly-radio"
                      v-model="searchTermRadio"
                      type="radio"
                      name="searchDateRadio"
                      value="weekly"
                      @click="searchRadioSelected('weekly')">
                    <div class="option-input"></div> ウィークリー(30日間)
                  </label>
                </div>
                <div class="radio">
                  <label for="monthly-radio">
                    <input
                      id="monthly-radio"
                      v-model="searchTermRadio"
                      type="radio"
                      name="searchDateRadio"
                      value="monthly"
                      @click="searchRadioSelected('monthly')">
                    <div class="option-input"></div> マンスリー(180日間)
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="c-btn-wrap roote-btn white-bacckground">
          <div
            class="c-btn c-btn--back c-btn--back-left roote-cange"
            @click.prevent="onReleaseDetailClicked($route.params.id)">
            リリース情報詳細
          </div>
          <router-link
            class="c-btn c-btn--back roote-cange"
            :to="{ name : 'link-create', params: { id : $route.params.id }}">
            Link設定
          </router-link>
        </div>

        <div>
          <link-analytic-detail-chart
            :analytic-data="analyticCountData"
            @filtered-type-ids="setTypeIds">
          </link-analytic-detail-chart>
          <div
            v-if="isTypeIdExist(1)"
            class="linkanalytic-pv__tables">
            <div class="linkanalytic-pv__title">
              <h3>PV</h3>
            </div>
            <table class="linkanalytic-list__table">
              <tbody class="linkanalytic-list__tbody">
                <tr>
                  <td class="linkanalytic-list__cell-pv">PV総数</td>
                  <td class="linkanalytic-list__cell-pv-total">{{ pvTotal }}</td>
                </tr>
              </tbody>
            </table>

            <div>
              <h3>リファラー</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.referrerDatas"
              :analytic-data="analyticData.referrerDatas.pv"
              display-name="referrer">
            </link-analytic-detail-table>
            <div>
              <h3>国</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.regionDatas"
              :analytic-data="analyticData.regionDatas.pv"
              display-name="name">
            </link-analytic-detail-table>
            <div>
              <h3>デバイス</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.deviceDatas"
              :analytic-data="analyticData.deviceDatas.pv"
              display-name="name">
            </link-analytic-detail-table>
          </div>
          <div
            v-if="isTypeIdExist(2)"
            class="linkanalytic-click__tables">
            <div class="linkanalytic-click__title">
              <h3>クリック</h3>
            </div>
            <div>
              <h3>ストア別クリック数</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.clickDatas"
              :analytic-data="analyticData.clickDatas.click"
              display-name="name">
            </link-analytic-detail-table>
            <div>
              <h3>リファラー</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.referrerDatas"
              :analytic-data="analyticData.referrerDatas.click"
              display-name="referrer">
            </link-analytic-detail-table>
            <div>
              <h3>国</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.regionDatas"
              :analytic-data="analyticData.regionDatas.click"
              display-name="name">
            </link-analytic-detail-table>
            <div>
              <h3>デバイス</h3>
            </div>
            <link-analytic-detail-table
              v-if="analyticData.deviceDatas"
              :analytic-data="analyticData.deviceDatas.click"
              display-name="name">
            </link-analytic-detail-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import HeaderBar from '../HeaderBar'
import LinkAnalyticDetailTable from './LinkAnalyticDetailTable'
import LinkAnalyticDetailChart from './LinkAnalyticDetailChart'

export default {
  name: 'LinkAnalyticDetail',
  components: {
    HeaderBar,
    LinkAnalyticDetailTable,
    LinkAnalyticDetailChart,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      countLoading: false,
      tableLoading: false,
      loading: false,
      searchFrom: '',
      searchTo: '',
      analyticData: {},
      analyticCountData: {},
      typeIds: [],
      searchTermRadio: '',
      minFrom: '',
      maxTo: '',
    }
  },
  computed: {
    datepickerInternalValueSearchFrom: {
      get() {
        return this.searchFrom
      },
      set(newValue) {
        if (this.searchFrom !== newValue) {
          this.searchFrom = newValue
          this.searchRadioUnselected()
        }
      },
    },
    datepickerInternalValueSearchTo: {
      get() {
        return this.searchTo
      },
      set(newValue) {
        if (this.searchTo !== newValue) {
          this.searchTo = newValue
          this.searchRadioUnselected()
        }
      },
    },
    pvTotal() {
      let pv = 0
      for (let i = 0; i < this.analyticCountData.count.pv.length; i += 1) {
        pv += parseInt(this.analyticCountData.count.pv[i].total_count, 10)
      }
      return pv
    },
  },
  mounted() {
    this.getMaxFromTo()
    this.searchTermRadio = 'daily'
    this.searchRadioSelected('daily')
  },
  methods: {
    async fetchTableItem() {
      const from = this.searchFrom
      const to = this.searchTo
      const type = 'all_table'
      const res = await window.axios.get(`/api/client/link-analytics/${this.$route.params.id}`, {
        params: {
          from,
          to,
          type,
        },
      })

      if (res.status === 404) {
        this.$router.push({ name: 'link-analytics-index' })
      }

      const { data } = res
      this.analyticData = this.changeFormat(data)

      this.tableLoading = false
      if (!this.countLoading) {
        this.loading = false
      }
    },
    async fetchCountItem() {
      const from = this.searchFrom
      const to = this.searchTo
      const type = 'all_count'
      const res = await window.axios.get(`/api/client/link-analytics/${this.$route.params.id}`, {
        params: {
          from,
          to,
          type,
        },
      })

      if (res.status === 404) {
        this.$router.push({ name: 'link-analytics-index' })
      }

      const { data } = res
      this.analyticCountData = data

      this.countLoading = false
      if (!this.tableLoading) {
        this.loading = false
      }
    },
    async getMaxFromTo() {
      const res = await window.axios.get(`/api/client/link-analytics/get-product-link/${this.$route.params.id}`)

      if (res.status === 404) {
        this.$router.push({ name: 'link-analytics-index' })
      }

      const { data } = res
      this.minFrom = data.created_at_date
      /**
      * NOTE : Non RFC2822/ISO date formats are discouraged
      * and will be removed in an upcoming major release.
      * 上記のWarning対策
      */
      const toDate = new Date(this.getMaxTo())
      this.maxTo = moment(toDate.toISOString()).format('YYYY-MM-DD')
    },
    onClickedSearch() {
      this.fetchCountItem()
      this.fetchTableItem()
    },
    onBackClicked() {
      this.$router.go(-1)
    },
    changeFormat(data) {
      const newData = Vue.util.extend({}, data)
      newData.regionDatas.pv = this.regionDataChangeFormat(newData.regionDatas.pv)
      newData.regionDatas.click = this.regionDataChangeFormat(newData.regionDatas.click)
      return newData
    },
    regionDataChangeFormat(targetRegionData) {
      const regionNewDatas = []
      const townDatas = []
      const regionNameCount = {}

      targetRegionData.forEach((val) => {
        if (val.country_name === '日本') {
          townDatas.push({
            name: val.region_name,
            total_count: val.total_count,
            parent_name: val.name,
          })
        }
        if (!regionNameCount[val.country_name]) {
          regionNameCount[val.country_name] = 0
        }
        regionNameCount[val.country_name] += Number(val.total_count)
      })

      Object.keys(regionNameCount).forEach((name) => {
        if (name === '日本') {
          regionNewDatas.push({
            name,
            total_count: regionNameCount[name],
            child_datas: townDatas,
          })
        } else {
          regionNewDatas.push({
            name,
            total_count: regionNameCount[name],
            child_datas: null,
          })
        }
      })

      return regionNewDatas
    },
    setTypeIds(typeIds) {
      this.typeIds = typeIds
    },
    isTypeIdExist(num) {
      return this.typeIds.includes(num)
    },
    searchRadioUnselected() {
      this.searchTermRadio = ''
    },
    getMaxTo() {
      const toDateObj = new Date()
      toDateObj.setDate(toDateObj.getDate() - 1)
      const toYear    = toDateObj.getFullYear()
      const toMonth   = toDateObj.getMonth() + 1
      const toDay     = toDateObj.getDate()
      return `${toYear}-${toMonth}-${toDay}`
    },
    searchRadioSelected(type) {
      const fromDateObj = new Date()
      switch (type) {
        case 'daily':
          fromDateObj.setDate(fromDateObj.getDate() - 8)
          break
        case 'weekly':
          fromDateObj.setDate(fromDateObj.getDate() - 31)
          break
        case 'monthly':
          fromDateObj.setDate(fromDateObj.getDate() - 181)
          break
        default:
          break
      }
      const fromYear    = fromDateObj.getFullYear()
      const fromMonth   = fromDateObj.getMonth() + 1
      const fromDay     = fromDateObj.getDate()
      this.searchFrom = `${fromYear}-${fromMonth}-${fromDay}`
      this.searchTo = this.getMaxTo()
      this.onClickedSearch()
    },
    async onReleaseDetailClicked(id) {
      const { data } = await window.axios.get(`/api/client/products/${id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      this.$router.push({ name: 'release-detail' })
    },
  },
}
</script>

<style scoped>
.artist-detail__name {
  word-break: break-all;
}

.product-modal {
  padding: 20px;
  text-align: left;
  height: 80vh;
  overflow: scroll;
}

@media screen and (min-width: 896px) {
  .c-btn-wrap--artist-detail-top {
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 20px;
    top: 0;
    width: 344px;
  }
}

@media screen and (max-width: 895px) {
  .c-btn-wrap--artist-detail-top {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}

@media screen and (min-width: 896px) {
  .c-btn--small {
    font-size: 1.8rem;
    min-width: 160px;
    padding: 9px 40px;
    text-align: center;
  }
}

@media screen and (max-width: 895px) {
  .c-btn--small {
    font-size: 3.73333vw;
    padding: 2.66667vw 5.33333vw;
    width: 48.5%;
  }
}

.white-bacckground {
  background-color: #fff;
  border-bottom: none;
}
.roote-cange {
  background: rgb(255, 49, 49);
}
.roote-btn {
  display: flex;
  justify-content: flex-end;
  margin: 20px 223px 0px 260px;
  padding: 0;
}
@media screen and (max-width: 895px) {
  .roote-btn {
    margin: 0;
    width: 100%;
    width: -502px;
    font-size: 3.7333333333vw;
    display: inline-block;
  }
  .roote-cange{
    width: 100%;
  }
}
@media screen and (max-width: 895px) {
  .roote-cange {
    width: 100%;
  }
  .c-btn--back-left{
    margin-bottom:10px;
  }
}
</style>
